export default "__VITE_ASSET__c91d009c__"